const prefix = 'INVENTORY_SUMMARY';

export const INVENTORY_SUMMARY_PAGE_REQUEST = `${prefix}_PAGE_REQUEST`;

export const INVENTORY_SUMMARY_SUMMARY_REQUEST = `${prefix}_SUMMARY_REQUEST`;

export const INVENTORY_SUMMARY_SET_OUTLETS = `${prefix}_SET_OUTLETS`;

export const INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS = `${prefix}_ON_CHANGE_OUTLET_IDS`;

export const INVENTORY_SUMMARY_ON_CHANGE_DATE = `${prefix}_ON_CHANGE_DATE`;

export const INVENTORY_SUMMARY_ON_CHANGE_KEYWORD = `${prefix}_ON_CHANGE_KEYWORD`;

export const INVENTORY_SUMMARY_SET_CURRENT_PAGE = `${prefix}_SET_CURRENT_PAGE`;

export const INVENTORY_SUMMARY_SET_TOTAL_PAGE = `${prefix}_SET_TOTAL_PAGE`;

export const INVENTORY_SUMMARY_SET_ITEMS = `${prefix}_SET_ITEMS`;

export const INVENTORY_SUMMARY_SET_ROW_ITEMS = `${prefix}_SET_ROW_ITEMS`;

export const INVENTORY_SUMMARY_EXPORT_SUMMARY = `${prefix}_EXPORT_SUMMARY`;

export const INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE = `${prefix}_ON_CHANGE_NAMESPACE`;

export const INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST = `${prefix}_INGREDIENT_INVENTORY_SUMMARY_REQUEST`;

export const INVENTORY_SUMMARY_SET_INGREDIENTS = `${prefix}_SET_INGREDIENTS`;

export const INVENTORY_SUMMARY_EXPORT_START = `${prefix}EXPORT_START`;

export const INVENTORY_SUMMARY_EXPORT_DONE = `${prefix}EXPORT_DONE`;

export const INVENTORY_SUMMARY_EXPORT_FAILED = `${prefix}EXPORT_FAILED`;

export const INVENTORY_SUMMARY_SET_ASYNCJOBID = `${prefix}SET_ASYNCJOBID`;
